import { getSegmentRoutePath } from './helpers';
import { Tab } from '../services/TabLinkService/types';
import history from '../history';

export function getRoleFromPath(path = ''): string {
  const newPath = path || history.location.pathname;
  let segmentPath = getSegmentRoutePath(newPath, 2); // user or admin;
  if (segmentPath !== 'user' && segmentPath !== 'admin') {
    segmentPath = 'user';
  }

  return segmentPath;
}


export const clipLastSegmentRoute = (path: string): string => {
  const array = path.split('/');
  array.pop();
  return array.join('/');
};

export const getLastSegmentRoute = (path: string): string => {
  const array = path.split('/');
  return array.pop() || '';
};


export function findIndexTab(tabs: Tab[], url: string): number {
  const index = tabs.findIndex((item) => item.to === url);
  if (index === -1 && url !== '') {
    return findIndexTab(tabs, clipLastSegmentRoute(url));
  }

  return index === -1 ? 0 : index;
};

export function cutSegmentsFromPath(path: string, repeat: number) {
  let currentPath = path;
  for (let i = 0; i < repeat; i += 1) {
    currentPath = clipLastSegmentRoute(currentPath);
  }

  return currentPath;
}

export function getResourceNameFromPath(): string {
  const path = window.location.pathname;
  let lastSegment = getLastSegmentRoute(clipLastSegmentRoute(path));
  if (!Number.isNaN(parseInt(lastSegment, 10))) {
    lastSegment = getLastSegmentRoute(clipLastSegmentRoute(clipLastSegmentRoute(path)));
  }

  switch (lastSegment) {
    case 'projects': return 'project';
    case 'organizations': return 'organization';
    case 'team': return 'team';
    case 'customers': return 'customer';
    case 'videos': return 'video';
    case 'video-menus': return 'video menu';
    case 'users':
    case 'billing':
    case 'new':
      return 'user';
    case 'promotion-codes': return 'promotion code';
    case 'orders': return 'order';
    default: return 'resource';
  }
}

export function getListRouteByDetailPageRoute(): string {
  const path = window.location.pathname;
  const segments = path.split('/').filter((segment) => segment.length > 0);

  const clearPathUpToList = (sgm: string[]): string[] => {
    if (!(sgm && sgm.length)) {
      return [];
    }

    const lastEl = sgm[sgm.length - 1];

    if (lastEl === 'new' || !Number.isNaN(parseInt(lastEl, 10))) {
      sgm.pop();
      return sgm;
    }

    sgm.pop();
    return clearPathUpToList(sgm);
  };

  const clearedSegments = clearPathUpToList(segments);

  return `/${clearedSegments.join('/')}`;
}
